//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { InstagramShopsItemFilter } from '@apis/instagram-shops/instagramShopsApiModel';
import { isInstagramShopsItemFilter } from '@instagram-account/redux/instagram-shops/feature-ugc/instagramShopsFeatureUgcModel';
import { getInstagramShopsFeatureUgc } from '@instagram-account/redux/instagram-shops/selectors/getInstagramShopsFeatureUgc';

export const getInstagramShopsItemFilter = createSelector(
  getInstagramShopsFeatureUgc,
  (featureUgc) => {
    return isInstagramShopsItemFilter(featureUgc.itemFilter)
      ? featureUgc.itemFilter
      : InstagramShopsItemFilter.IsApprovedNotFeatured;
  },
);
